(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/prevent-double-click/assets/javascripts/prevent-double-click.js') >= 0) return;  svs.modules.push('/components/lb-utils/prevent-double-click/assets/javascripts/prevent-double-click.js');

'use strict';

const logger = new svs.core.log.Logger('svs.lbUtils.preventDoubleClick');
const preventDoubleClick = function (callback) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
  return e => {
    const el = e.currentTarget;
    const method = el.style.removeProperty ? 'removeProperty' : 'removeAttribute';
    let _disabled;
    let _class;
    let _select;
    const releaseMethod = () => {
      if (!_disabled) {
        el.removeAttribute('disabled');
      }
      if (!_class) {
        el.classList.remove('disabled');
      }
      if (!_select) {
        el.style[method]('user-select');
      }
      delete el.dataset.preventDoubleClick;
      _disabled = null;
      _class = null;
      _select = null;
      logger.debug('release');
    };
    if (!el.dataset.preventDoubleClick) {
      logger.debug("block ".concat(delay, "ms"));
      _disabled = Boolean(el.getAttribute('disabled'));
      _class = el.classList.contains('disabled');
      _select = Boolean(el.style.userSelect);
      el.setAttribute('disabled', 'disabled');
      el.classList.add('disabled');
      el.style.userSelect = 'none';
      el.dataset.preventDoubleClick = setTimeout(releaseMethod, delay);
      return callback(e);
    }
    clearTimeout(Number(el.dataset.preventDoubleClick));
    el.dataset.preventDoubleClick = setTimeout(releaseMethod, delay);
    logger.debug("reset timer ".concat(delay, "ms"));
    return false;
  };
};
setGlobal('svs.components.lbUtils.preventDoubleClick', preventDoubleClick);

 })(window);